import { ShowerHead, Droplet, Square, LayoutPanelLeft, PaintRoller, Zap, Home, Camera, Bath, HelpCircle } from "lucide-react";
import { COMPANY } from "@/data/services";

const NEEDS = [
  { id: 'bano-ducha', label: 'Quiero reformar un baño', icon: ShowerHead },
  { id: 'bano-ducha', label: 'Cambiar bañera por plato de ducha', icon: Bath, itemId: 'bd-cambio-basico' },
  { id: 'impermeabilizacion', label: 'Tengo filtración o humedad', icon: Droplet },
  { id: 'pavimentos', label: 'Quiero poner suelo', icon: Square },
  { id: 'pladur', label: 'Pladur o falso techo', icon: LayoutPanelLeft },
  { id: 'pintura', label: 'Pintar mi vivienda', icon: PaintRoller },
  { id: 'fontaneria', label: 'Necesito fontanería', icon: Droplet },
  { id: 'electricidad', label: 'Necesito electricidad', icon: Zap },
  { id: 'reformas-integrales', label: 'Reforma integral', icon: Home },
];

export default function NeedHelper() {
  const handleSelect = (n) => {
    window.dispatchEvent(new CustomEvent("ps24-select-service", { detail: { id: n.id, itemId: n.itemId } }));
    setTimeout(() => {
      document.querySelector('#calculadora')?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  };

  const msg = encodeURIComponent(`Hola, quiero enviar fotos de un trabajo para que ${COMPANY.name} pueda orientarme con una estimación inicial.`);

  return (
    <section id="necesidades" className="bg-slate-50/60 border-y border-slate-200 scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Empieza por aquí</div>
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">
            ¿Qué necesitas reformar o solucionar?
          </h2>
          <p className="text-slate-500 mt-3">Pulsa una opción y te llevamos directamente a la partida correspondiente.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {NEEDS.map((n, i) => (
            <button
              key={i}
              type="button"
              onClick={() => handleSelect(n)}
              data-testid={`need-card-${i}`}
              className="group flex flex-col items-start gap-3 p-4 rounded-xl border border-slate-200 bg-white hover:border-[#004B87] hover:bg-[#E6F0FA]/40 hover:-translate-y-0.5 hover:shadow-md transition-all text-left"
            >
              <div className="w-10 h-10 rounded-lg bg-[#E6F0FA] text-[#004B87] grid place-items-center group-hover:bg-[#004B87] group-hover:text-white transition-colors">
                <n.icon className="w-5 h-5" />
              </div>
              <div className="text-sm font-display font-semibold text-slate-900 leading-tight">{n.label}</div>
            </button>
          ))}
          <a
            href={`https://wa.me/${COMPANY.whatsappIntl}?text=${msg}`}
            target="_blank" rel="noreferrer"
            data-testid="need-card-fotos"
            className="group flex flex-col items-start gap-3 p-4 rounded-xl border-2 border-dashed border-[#004B87]/40 bg-[#004B87]/5 hover:bg-[#004B87] hover:border-[#004B87] hover:text-white text-left transition-all"
          >
            <div className="w-10 h-10 rounded-lg bg-white text-[#004B87] grid place-items-center group-hover:bg-white">
              <HelpCircle className="w-5 h-5" />
            </div>
            <div className="text-sm font-display font-semibold leading-tight text-slate-900 group-hover:text-white">No sé qué necesito,<br/>envío fotos por WhatsApp</div>
          </a>
        </div>

        {/* Bloque "No sé las medidas" */}
        <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-5">
          <div className="w-14 h-14 rounded-xl bg-[#E6F0FA] text-[#004B87] grid place-items-center shrink-0">
            <Camera className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <div className="font-display font-semibold text-slate-900 text-lg">¿No sabes los m² exactos?</div>
            <p className="text-slate-600 text-sm mt-1 leading-relaxed">No te preocupes. Puedes enviarnos fotos por WhatsApp y una breve descripción del trabajo para orientarte mejor.</p>
          </div>
          <a
            href={`https://wa.me/${COMPANY.whatsappIntl}?text=${msg}`}
            target="_blank" rel="noreferrer"
            data-testid="send-photos-btn"
            className="inline-flex items-center gap-2 h-12 px-5 rounded-lg bg-[#004B87] text-white font-medium hover:bg-[#003A6A] transition-colors whitespace-nowrap"
          >
            Enviar fotos por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
